import React from "react";
import { useAuth } from "@/context/AuthContext";
import StandardDashboard from "@/pages/dashboard/StandardDashboard";
import ProDashboard from "@/pages/dashboard/ProDashboard";

const DashboardPage = () => {
  const { user } = useAuth();
  return user?.account_type === "pro"
    ? <ProDashboard user={user} />
    : <StandardDashboard user={user} />;
};

export default DashboardPage;
